const GET_WEATHER = 'GET_WEATHER';

const initialState = {
  error: null,
  data: null,
  loaded: false,
  loading: false,
};

export default function weather(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_WEATHER}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
      };
    case `${GET_WEATHER}_SUCCESS`:
      return {
        ...state,
        error: null,
        data: action.result,
        loaded: true,
        loading: false,
      };
    case `${GET_WEATHER}_FAIL`:
      return {
        ...state,
        error: action.error,
        data: null,
        loaded: false,
        loading: false,
      };
    default:
      return state;
  }
}
